export enum PayrollBreakdown {
  None = 0,
  ByCompany = 1,
  ByDivision = 2
}

export const PayrollBreakdownMapping: Record<PayrollBreakdown, string> = {
  [PayrollBreakdown.None]: 'None',
  [PayrollBreakdown.ByCompany]: 'By Company',
  [PayrollBreakdown.ByDivision]: 'By Division'
};
